import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'orderBy',
	standalone: true
})
export class SortByPipe implements PipeTransform {

	/**
	 * @description Sorts the input array in descending order by the fieldToOrderBy passed in.
	 **/
	public transform(value: any[], fieldToOrderBy = '') {
		const sortedCopy = [...value];
		return this.sortPrices(sortedCopy, fieldToOrderBy);
	}

	private sortPrices(list: any[], fieldToOrderBy: string) {

		list.sort((eleA, eleB) => {
			if (!eleA[fieldToOrderBy]) {
				return -1;
			} else {
				return eleB[fieldToOrderBy] - eleA[fieldToOrderBy];
			}
		});

		return list;
	}
}
